import {
  AncillariesBundleConfig,
  AncillariesBundleItemConfig,
} from '../../../AncillariesBundles';

export const mapTableRows = (bundles: AncillariesBundleConfig[]) => {
  // Collect unique items from bundles
  const uniqueItems = bundles
    .flatMap((bundle) => bundle.items)
    .reduce(
      (accumulator, item) => {
        if (!accumulator[item.code]) {
          accumulator[item.code] = item;
        }
        return accumulator;
      },
      {} as Record<string, AncillariesBundleItemConfig>,
    );

  const uniqueCodes = Object.keys(uniqueItems);

  // Create rows based on unique IDs
  const rows = uniqueCodes.map((code) =>
    bundles.map((bundle) => {
      const item = bundle.items.find((item) => item.code === code);
      if (bundle.recommended) {
        return {
          recommended: true,
          ...(item || { ...uniqueItems[code], included: false }),
        };
      }

      return item || { ...uniqueItems[code], included: false };
    }),
  );

  return rows as (AncillariesBundleItemConfig & { recommended?: boolean })[][];
};
